// extracted by mini-css-extract-plugin
export default {"description":"QuizEndingButtons_description__jptC9"};